import { restResourceRequester } from "../rest-resource-requester";
import { UpdateRootComponentResponse } from "./update-root-component/UpdateRootComponentResponse";
import { UpdateRootComponentRequest } from "./update-root-component/UpdateRootComponentRequest";
import { CreateRootComponentRequest } from "../root-component/create-root-component/CreateRootComponentRequest";
import { CreateRootComponentResponse } from "../root-component/create-root-component/CreateRootComponentResponse";

interface RootComponentRestResource {
  updateRootComponent(
    request: UpdateRootComponentRequest,
  ): Promise<UpdateRootComponentResponse>;
  createRootComponent(
    request: CreateRootComponentRequest,
  ): Promise<CreateRootComponentResponse>;
}

const REST_RESOURCE_NAME = "/root-component";

/**
 * PUT /root-component/{rootComponentId}
 */
const updateRootComponent = restResourceRequester<
  UpdateRootComponentRequest,
  UpdateRootComponentResponse
>(
  "PUT",
  (request) => {
    return `${REST_RESOURCE_NAME}/${request.rootCpntId}`;
  },
  (request) => JSON.stringify(request),
);

/**
 * PUT /root-component
 */
const createRootComponent = restResourceRequester<
  CreateRootComponentRequest,
  CreateRootComponentResponse
>(
  "PUT",
  (request) => {
    return `${REST_RESOURCE_NAME}`;
  },
  (request) => JSON.stringify(request),
);
export const rootComponentRestResource: RootComponentRestResource = {
  updateRootComponent: updateRootComponent,
  createRootComponent: createRootComponent,
};
